import type { SerializedError } from '@reduxjs/toolkit';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';

// Type predicate to narrow an unknown error to `FetchBaseQueryError`
function isFetchBaseQueryError(error: unknown): error is FetchBaseQueryError {
  return typeof error === 'object' && error !== null && 'status' in error;
}

function isSerializedError(error: unknown): error is SerializedError {
  return typeof error === 'object' && error !== null && ('name' in error || 'message' in error || 'code' in error);
}

export function getGuidesApiErrorMessage(err: FetchBaseQueryError | SerializedError | undefined): string | undefined {
  const unknonwErrorMessage = 'Something went wrong. Please try again or contact support if the issue persists.';
  if (err === undefined) {
    return undefined;
  }
  if (isFetchBaseQueryError(err) && 'error' in err) {
    switch (err.status) {
      case 'FETCH_ERROR':
        return 'Our system is experiencing problems right now. Try again later or contact support if the problem persists.';
      case 'PARSING_ERROR':
        return 'Unexpected response from the server. Please try again or contact support if the issue continues.';
      default:
        return err.error;
    }
  }
  if (isSerializedError(err)) {
    return err.message ?? unknonwErrorMessage;
  }

  return unknonwErrorMessage;
}

export function GetSentryEventId(
  err: (FetchBaseQueryError & { sentryId?: string }) | SerializedError | undefined,
): string | undefined {
  if (err !== undefined && 'sentryId' in err) {
    return err.sentryId;
  }
  return undefined;
}
